module.exports = __webpack_public_path__ + "static/media/PLAYER7.27f310e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Element/img/PLAYER7.png
// module id = 273
// module chunks = 0